import { deleteSalaryAddition, getSalaryAdditions, postSalaryAdditions } from "@/services/salaryService";
import dateFormatter from "@/utility/dateFormatter";
import priceFormatter from "@/utility/priceFormatter";
import Vue from "vue";
export default Vue.extend({
    props: {
        employee: {},
        selectedDate: String,
    },
    data() {
        return {
            additionHeaders: [
                { text: "Description", value: "name" },
                { text: "Activity type", value: "" },
                {
                    text: "Payout",
                    value: "variablePayment",
                    align: "right",
                    sortable: false,
                },
                {
                    text: "Remove",
                    value: "action",
                    width: "100px",
                    sortable: false,
                    align: "center",
                },
            ],
            additions: [],
            loadingAdditions: false,
            addAdditionMenu: false,
            activity: undefined,
            payout: undefined,
        };
    },
    async mounted() {
        await this.loadAdditions();
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
    },
    computed: {
        selectedMonth() {
            return dateFormatter.fromDateString(this.selectedDate).getMonth();
        },
        selectedYear() {
            return dateFormatter.fromDateString(this.selectedDate).getYear();
        },
    },
    methods: {
        async loadAdditions() {
            this.loadingAdditions = true;
            this.additions = await getSalaryAdditions(this.selectedYear, this.selectedMonth, this.employee.userId);
            this.loadingAdditions = false;
        },
        async onAddAddition() {
            this.addAdditionMenu = false;
            const addition = {
                name: this.activity,
                variablePayment: this.payout,
            };
            this.loadingAdditions = true;
            await postSalaryAdditions(this.selectedYear, this.selectedMonth, this.employee.userId, addition);
            await this.loadAdditions();
            this.$emit("update:additions");
            this.activity = undefined;
            this.payout = undefined;
        },
        async onRemoveAddition(addition) {
            console.log(addition);
            await deleteSalaryAddition(addition.userId, addition.id, addition.type);
            await this.loadAdditions();
            this.$emit("update:additions");
        },
    },
});
